import FiniquitoMdl from '@/models/HumanResource/HRFiniquito'
export default async (finiquitoId) => {
    try {
        let finiquito = await FiniquitoMdl.find(finiquitoId)
        let response = await finiquito.delete()
        return response
    } catch (error) {
        return error.response.data
    }
}